import {
  BODY_PART_DATA_GET, POINTER_ADD, POINTER_DELETE, POINTER_GET,
} from './action-modulation.type';
import SkeletonService from '../services/skeleton.service';

export const state = {
  touchedParts: null,
  partsData: null,
};

export const actions = {
  [POINTER_ADD](context, pointer) {
    return SkeletonService.addSkeletonPointers(pointer).then(() => {
    }).catch((error) => {
      throw new Error(error);
    });
  },
  [POINTER_DELETE](context, pointer) {
    return SkeletonService.deleteSkeletonPointer(pointer).then(() => {
    }).catch((error) => {
      throw new Error(error);
    });
  },
  [POINTER_GET](context, pointer) {
    return SkeletonService.getSkeletonPointer(pointer).catch((error) => {
      throw new Error(error);
    });
  },
  [BODY_PART_DATA_GET]() {
    return SkeletonService.getSkeletonsParts().catch((error) => {
      throw new Error(error);
    });
  },
};

export const mutations = {
  [POINTER_ADD](state, pointer) {
    state.touchedParts = pointer;
  },
  [BODY_PART_DATA_GET](state, data) {
    state.partsData = data;
  },
};


export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/skeleton.module.js